import { YhConfigProvider } from '@yhui/components/config-provider'
import { YhDialog } from '@yhui/components/dialog'
import { YhTable } from '@yhui/components/table'

import type { Plugin } from 'vue'

export default [YhConfigProvider, YhDialog, YhTable] as Plugin[]
